import React from 'react';

import Header from './Header';

function PublicLayout({ children, title }) {
  return (
    <div className="flex flex-col min-h-screen bg-hdlcc-black">
      <Header />
      <main className="flex-grow bg-hdlcc-black p-4">
        <div className="max-w-4xl mx-auto">
          {title && <h1 className="text-2xl font-bold text-white mb-8">{title}</h1>}
          {children}
        </div>
      </main>
      <footer className="bg-hdlcc-black text-white text-center py-4 border-t border-hdlcc-gray">
        <p>&copy; 2025 Hagley & District Light Car Club Ltd.</p>
        <p className="text-sm text-gray-400">
          Registered in England No. 898044 • VAT No. 589 2250 11
        </p>
      </footer>
    </div>
  );
}

export default PublicLayout;
